// extracted by mini-css-extract-plugin
export var divider = "_vo-0";